import { render, staticRenderFns } from "./DashboardV2.vue?vue&type=template&id=c79fce8c&scoped=true&"
import script from "./DashboardV2.vue?vue&type=script&lang=js&"
export * from "./DashboardV2.vue?vue&type=script&lang=js&"
import style0 from "./DashboardV2.vue?vue&type=style&index=0&id=c79fce8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79fce8c",
  null
  
)

export default component.exports